import React, { useEffect, useState } from "react";
import classnames from "classnames";

import { valueAppendedOrReplacedByType } from "../../attributes/lib/helpers";
import { getProvider } from "./data";
import { getDefaultValueByType } from "../../attributes/lib/attribute-data";

const withSuggestedValue = (WrappedComponent) => (props) => {
    const [suggestions, setSuggestions] = useState([]);
    const additionalInfo = props.attribute.additionalInfo;
    const suggestedValueProvider = additionalInfo && additionalInfo.suggestedValueProvider ? additionalInfo.suggestedValueProvider : null;
    const dataType = props.dataType;

    useEffect(() => {
        const fetchData = async () => {
            const response = suggestedValueProvider ? await getProvider(suggestedValueProvider) : null;

            if (!response) {
                return;
            }

            setSuggestions(response);
        };

        fetchData();
    }, []);

    const handleUpdate = (value) => {
        const oldValue = (props.defaultValue ? props.defaultValue : props.value) || getDefaultValueByType(dataType);
        // String updates value, StringList appends value
        const useValue = valueAppendedOrReplacedByType(dataType, value, oldValue);

        if (props.updateOnChange) {
            props.updateOnChange(props.name, useValue);
        }

        if (props.updateOnBlur) {
            props.updateOnBlur(props.name, useValue);
        }
    };

    const suggestionList = suggestions.map((value, index) => {
        //TODO: needs to handle different dataTypes
        const comma = index + 1 < suggestions.length ? "," : "";

        return (
            <li key={`suggestion_${index}`}>
                <button
                    key={`suggestion_${index}`}
                    className={classnames("button -text", {
                        "-selected": value === props.defaultValue,
                    })}
                    onClick={() => {
                        handleUpdate(value);
                    }}
                    disabled={props.disabled}
                >
                    {value}
                    {comma}
                </button>
            </li>
        );
    });

    // Bypass input if no suggestedProvider
    if (!suggestedValueProvider) {
        return <WrappedComponent {...props} />;
    }

    return (
        <div className="suggestion-wrapper">
            <WrappedComponent {...props} />
            <ul className="suggestion-list">{suggestionList}</ul>
        </div>
    );
};

export default withSuggestedValue;
